import _ from 'lodash';

// Acronyms and product terms that startCase would otherwise title-case wrongly
// (e.g. 'qboConnectionId' -> 'Qbo Connection Id'). Keyed by the lowercased word.
const OVERRIDES = {
  ai: 'AI',
  api: 'API',
  bamboohr: 'BambooHR',
  csv: 'CSV',
  hubspot: 'HubSpot',
  id: 'ID',
  macos: 'macOS',
  pdf: 'PDF',
  qbo: 'QBO',
  sso: 'SSO',
  url: 'URL',
  utm: 'UTM',
};

// Turns an internal identifier (camelCase, snake_case, kebab-case, or dotted) into
// a human-readable label: 'billableAmount' -> 'Billable Amount', 'qboConnectionId'
// -> 'QBO Connection ID', 'set_active' -> 'Set Active'. Built on lodash startCase
// for robust word splitting, then restores known acronyms via OVERRIDES.
function humanize(value) {
  if (typeof value !== 'string' || !value) return '';
  return _.startCase(value)
    .split(' ')
    .map((word) => OVERRIDES[word.toLowerCase()] ?? word)
    .join(' ');
}

export default humanize;
